export default {
  copyToClipboard(hash: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(hash)
    } else {
      // Fallback method for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = hash;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        // console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textArea);
    }
  },
  isTextEqualTo(txt: string, txt2: string, uId = 0) {
    try {
      return txt+uId === txt2;
    } catch (err) {
      // console.error('Failed to read clipboard contents: ', err);
      return false;
    }
  },
  getShortenHash(hash: string) {
    if (!hash) return;

    if (hash.length > 11) {
      return hash.substr(0, 4) + '...' + hash.substr(hash.length-7, hash.length);
    }
    return hash;
  },
  async readFromClipboard() {
    return await navigator.clipboard.readText();
  },
  modifyMetadata(item: any) {
    if (!item.metaData || !item.metaData.length) return [];

    if (item.type === 'stack') {
      const modifiedPayload = item.metaData.map((item: any) => {
        return item && item.substring(2);
      })

      return modifiedPayload;
    }

    return item.metaData;
  },
}
